export default __webpack_public_path__ + "static/media/trash.9cba6318.png";